import PropTypes from "prop-types"
import React, { useEffect, useState, useMemo, useCallback } from "react"
import { Input } from "reactstrap"
import { Link } from "react-router-dom"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import TableContainer from "../../components/Common/TableContainer"
import { withTranslation } from "react-i18next"
import { get, del } from "helpers/api_helper"
import { checkScope } from "helpers/utility_helper"
import "../../components/Common/datatables.scss"
import Spinners from "components/Common/Spinner"

const LineSettingList = props => {
  const deleteRow = useCallback(
    id => () => {
      if (confirm("Are you sure?") == true) {
        const doDelete = async () => {
          try {
            await del(
              process.env.REACT_APP_BACKEND_URL +
                `/v1/admin/line-oa/${id}`
            )
            setLineList(prev => prev.filter(item => item.id !== id))
          } catch (err) {
            console.error("Delete failed:", err)
          }
        }
        doDelete()
      }
    },
    []
  )

  const columns = useMemo(
    () => [
      {
        header: "#",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return (
            <div style={{ display: "flex", justifyContent: "center" }}>
              {parseInt(cellProps.row.id) + 1}
            </div>
          )
        },
      },
      {
        header: "Line OA Account",
        accessorKey: "oa_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Tools",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: false,
        cell: cellProps => {
          let _lineID = cellProps.row.original.id
          return (
            <>
              <Link
                className={`btn btn-info`}
                to={`/systemsettings/linesetting/history/${_lineID}`}
              >
                <i className={`bx bx-history`}></i>
              </Link>
              &nbsp;
              {checkScope("systemsettings:linesetting:update") && (
                <Link
                  className={`btn btn-warning`}
                  to={`/systemsettings/linesetting/edit/${_lineID}`}
                >
                  <i className={`bx bx-edit-alt`}></i>
                </Link>
              )}
              &nbsp;
              {checkScope("systemsettings:linesetting:delete") && (
                <Link
                  className={`btn btn-danger`}
                  onClick={deleteRow(_lineID)}
                >
                  <i className={`bx bx-trash`}></i>
                </Link>
              )}
            </>
          )
        },
      },
    ],
    []
  )

  const [lineList, setLineList] = useState([])
  const [lineListLoading, setLineListLoading] = useState(false)

  useEffect(() => {
    setLineListLoading(true)
    const fetchLineList = async () => {
      try {
        const result = await get(
          process.env.REACT_APP_BACKEND_URL +
            "/v1/admin/line-oa"
        )
        setLineList(result.data || [])
      } catch (err) {
        console.error("Fetch line list failed:", err)
        setLineList([])
      }
    }
    fetchLineList()
  }, [])

  useEffect(() => {
    setLineListLoading(false)
  }, [lineList])

  document.title = "Line Account Setting | " + process.env.REACT_APP_CMS_TITLE

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="System Setting" breadcrumbItem="Line Account Setting" />

        <div className="bInnerContent">
          {lineListLoading ? (
            <Spinners setLoading={setLineListLoading} />
          ) : (
            <TableContainer
              isAddButton={true}
              addRowLink={`/create`}
              isExportButton={false}
              columns={columns}
              data={lineList || []}
              isGlobalFilter={true}
              isPagination={true}
              SearchPlaceholder="Search"
              pagination="pagination"
              paginationWrapper="dataTables_paginate paging_simple_numbers"
              tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
              rootMenu="systemsettings"
              subMenu="linesetting"
              isCustomPageSize={true}
            />
          )}
        </div>
      </div>
    </div>
  )
}

LineSettingList.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(LineSettingList)
